import get from 'transmute/get';
import { RECIPIENT_ID, RECIPIENT_TYPE } from '../constants/recipientLocatorKeyPaths';
export const getRecipientId = get(RECIPIENT_ID);
export const getRecipientType = get(RECIPIENT_TYPE);